import * as React from "react";
const PieChart = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 97 97", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "#CFCFCF", d: "M48.6 95.4c25.958 0 47-21.042 47-47s-21.042-47-47-47-47 21.043-47 47 21.043 47 47 47" }),
    React.createElement("mask", { id: "prefix__a", width: 95, height: 95, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M96 1H1v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#ED0000", d: "M48.9 17C66.1 17 80 30.9 80 48.2v.2h15.6c0-26-21-47-47-47V17z" })),
    React.createElement("mask", { id: "prefix__b", width: 95, height: 95, x: 1, y: 1, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M96 1H1v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__b)" },
        React.createElement("path", { fill: "#3F3F3F", d: "M48.9 17h-.2v31.4H80v-.2C80 30.9 66.1 17 48.9 17" }))));
export default PieChart;
//# sourceMappingURL=PieChart.js.map